import { createClient } from 'graphqurl';
import { getVariableOrDefault } from './utils/env';

const endpoint = getVariableOrDefault(
  'VUE_APP_THEME_SERVICE_URL',
  'https://c360-be.stg.adportal.io/graphql',
);

const WHAT_IS_NEW_DIALOG_QUERY = `
  query ($product: String!) {
    whatsNewDialog(product: $product) {
      enabled
      start
      end
      userShouldSeeIt
      id
    }
  }
`;

const WHAT_IS_NEW_ARTICLE_QUERY = `
  query ($product: String!) {
    whatsNewArticle(product: $product) {
      body
      updatedAt
    }
  }
`;
const RECORD_WHATS_NEW_DIALOG_VIEW = `
  mutation ($dialogId: String!) {
    recordWhatsNewDialogView(dialogId: $dialogId) {
      success
    }
  }
`;

export const getWhatsNewDialog = async (product, token) => {
  try {
    const gqlClient = createClient({
      endpoint,
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const { data } = await gqlClient.query({
      query: WHAT_IS_NEW_DIALOG_QUERY,
      variables: { product },
    });
    return data.whatsNewDialog;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getWhatsNewArticle = async (product, token) => {
  try {
    const gqlClient = createClient({
      endpoint,
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const {
      data: { whatsNewArticle },
    } = await gqlClient.query({
      query: WHAT_IS_NEW_ARTICLE_QUERY,
      variables: { product },
    });
    return whatsNewArticle;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const recordWhatsNewDialogViewQgl = async (dialogId, token) => {
  try {
    const gqlClient = createClient({
      endpoint,
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const {
      data: { recordWhatsNewDialogView },
    } = await gqlClient.query({
      query: RECORD_WHATS_NEW_DIALOG_VIEW,
      variables: { dialogId },
    });
    return recordWhatsNewDialogView;
  } catch (error) {
    console.error(error);
    return [];
  }
};
